import React from 'react';

const StatusSecond = ({ color = '#222222' }: { color?: string }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
    >
      <path
        fill={color}
        d='M16 6v8h3v8h2V2c-2.76 0-5 2.24-5 4m-5 3H9V2H7v7H5V2H3v7c0 2.21 1.79 4 4 4v9h2v-9c2.21 0 4-1.79 4-4V2h-2z'
        stroke-width='0.4'
        stroke={color}
      />
    </svg>
  );
};

export default StatusSecond;
